<p-sidebar [(visible)]="sidebarVisible" position="right" [modal]="false" [style]="{width: '400px'}" class="notifications-sidebar">
  <div class="notifications-header">
    <div class="header-content">
      <h3 class="header-title">
        <i class="pi pi-bell"></i>
        Notificações
      </h3>
      <div class="header-actions">
        <button pButton type="button" icon="pi pi-check-double" 
                class="p-button-text p-button-sm mark-all-read-btn"
                [disabled]="!hasUnreadNotifications()"
                (click)="marcarTodasComoLidas()"
                pTooltip="Marcar todas como lidas">
        </button>
        <button pButton type="button" icon="pi pi-trash" 
                class="p-button-text p-button-sm clear-all-btn"
                [disabled]="!notificacoes?.length"
                (click)="limparTodasNotificacoes()"
                pTooltip="Limpar todas">
        </button>
        <button pButton type="button" icon="pi pi-times" 
                class="p-button-text p-button-sm close-btn"
                (click)="sidebarVisible = false"
                pTooltip="Fechar">
        </button>
      </div>
    </div>
    <div class="notifications-stats">
      <span class="stats-text">
        {{ getUnreadCount() }} não lidas de {{ notificacoes?.length || 0 }} total
      </span>
    </div>
  </div>

  <div class="notifications-content">
    <div *ngIf="notificacoes?.length > 0" class="notifications-list">
      <div *ngFor="let notificacao of notificacoes; trackBy: trackByNotificacao" 
           class="notification-card"
           [ngClass]="{
             'unread': !notificacao.estaLida,
             'read': notificacao.estaLida,
             'urgent': notificacao.assunto?.toLowerCase().includes('urgente') || notificacao.titulo?.toLowerCase().includes('urgente'),
             'important': notificacao.assunto?.toLowerCase().includes('importante') || notificacao.titulo?.toLowerCase().includes('importante')
           }">
        
        <div class="notification-indicator" *ngIf="!notificacao.estaLida"></div>
        
        <div class="notification-icon">
          <i class="pi" [ngClass]="getNotificationIcon(notificacao)"></i>
        </div>
        
        <div class="notification-body" (click)="marcarComoLida(notificacao)">
          <div class="notification-header">
            <h4 class="notification-title">{{ notificacao.titulo }}</h4>
            <div class="notification-time">
              <i class="pi pi-clock"></i>
              {{ getNotificationTime(notificacao) }}
            </div>
          </div>
          
          <p class="notification-content">{{ notificacao.conteudo }}</p>
          
          <div class="notification-actions">
            <button pButton type="button" 
                    [label]="notificacao.estaLida ? 'Marcar como não lida' : 'Marcar como lida'"
                    [icon]="notificacao.estaLida ? 'pi pi-eye-slash' : 'pi pi-check'"
                    class="p-button-text p-button-sm action-btn"
                    (click)="toggleReadStatus(notificacao, $event)">
            </button>
            <button pButton type="button" 
                    label="Remover"
                    icon="pi pi-trash"
                    class="p-button-text p-button-sm action-btn delete-btn"
                    (click)="removerNotificacao(notificacao, $event)">
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <div *ngIf="!notificacoes?.length" class="empty-notifications">
      <div class="empty-icon">
        <i class="pi pi-bell-slash"></i>
      </div>
      <h4 class="empty-title">Nada de novo por aqui</h4>
      <p class="empty-description">Você está em dia com suas notificações!</p>
      <button pButton type="button" 
              label="Verificar novamente"
              icon="pi pi-refresh"
              class="p-button-outlined refresh-btn"
              (click)="carregaListaNotificao()">
      </button>
    </div>
  </div>
</p-sidebar>

<p-confirmDialog></p-confirmDialog>
<div class="grid col-12 p-0 m-0">
  <div class="col-12 topNavBar">
    <div class="flex align-items-center">
      <a class="cursor-pointer no-underline text-white flex align-items-center" href="/">
        <img [src]="logoUrl" 
             alt="Logo" 
             style="height: 60px; width: auto;" 
             (error)="onLogoError($event)"
             (load)="onLogoLoad($event)">
      </a>
    </div>

    <div class="flex align-items-center justify-content-center">
      <app-global-search (resultSelected)="onSearchResultSelected($event)"></app-global-search>
    </div>
    <div class="flex align-items-center justify-content-end gap-3 top-nav-user-area">
      <div class="cache-clear-group">
        <span class="cache-clear-hint">Problemas no sistema? Limpe o cache.</span>
        <button
          pButton
          label="Limpar cache"
          icon="pi pi-refresh"
          class="p-button-text cache-clear-btn"
          pTooltip="Remove dados temporários do navegador e recarrega a página"
          tooltipPosition="bottom"
          (click)="limparCache()">
        </button>
      </div>
      <div class="flex flex-column align-items-end text-200 user-info-block">
        <p class="m-0 text-sm">{{ nomeUsuario }}</p>
        <p class="m-0 text-xs">Administrador</p>
        <p class="m-0 text-xs version-text">v{{ appVersion }}</p>
      </div>
      <div class="notification-badge-container" (click)="sidebarVisible = true">
        <p-avatar class="cursor-pointer notification-avatar" 
                  image="/assets/img/UserPicture.svg"
                  shape="circle">
        </p-avatar>
        <div class="notification-badge" *ngIf="getUnreadCount() > 0">
          <span class="badge-count">{{ getUnreadCount() > 99 ? '99+' : getUnreadCount() }}</span>
        </div>
        <div class="notification-pulse" *ngIf="getUnreadCount() > 0"></div>
      </div>
    </div>
  </div>

  <div class="col-12 menubar-container">
    <p-menubar class="custom-menubar" [model]="items"></p-menubar>
    <button pButton label="Sair" icon="pi pi-sign-out" class="p-button-text sair-btn" (click)="deslogar()"></button>
  </div>
</div>
